<app-modal
  [modalType]="InfoModalVariant.INFO"
  [titleTransKey]="'CONFIRM_PROFILE_MODAL_TITLE'"
  [infoTextTransKey]="'CONFIRM_PROFILE_MODAL_TEXT'"
  [confirmBtnTextTransKey]="'CONFIRM_PROFILE_MODAL_CONFIRM_BUTTON'"
  [cancelBtnTextTransKey]="'CONFIRM_PROFILE_MODAL_CANCEL_BUTTON'"
  [isCancelBtnHidden]="false"
  (onButtonClose)="onButtonClose()"
  (onButtonConfirm)="onButtonConfirm()"
/>
@if (error()) {
  <div class="container mx-auto max-w-xl mt-32 mb-32">
    <h2>{{ 'SOMETHING_WENT_WRONG' | translate }}</h2>
    <lds-button (clicked)="tryAgain()">
      {{ 'TRY_AGAIN' | translate }}
    </lds-button>
  </div>
}
@if (!error() && !isLoading()) {
  <div class="container mx-auto mt-32 mb-32 sm:max-w-[347px]">
    <div class="flex flex-col mx-4 justify-center break-words">
      <h1 class="text-display-lg mb-12 sm:max-w-[1317px]">
        {{ 'PERSONAL_DATA_TITLE' | translate }}
      </h1>
      <div class="mb-8">
        @if (region === 'eu') {
          <p class="mb-4">
            <strong>
              {{ 'FIRST_NAME_AND_SURNAME_TEXT' | translate }}
            </strong>
          </p>
          <p>{{ user()?.firstName }} {{ user()?.lastName }}</p>
        }
        <p class="mb-4 mt-6">
          <strong>{{ 'EMAIL_TEXT' | translate }}</strong>
        </p>
        <p>{{ user()?.email }}</p>
        <p class="mb-4 mt-6">
          <strong>{{ 'PHONE_NUMBER_TEXT' | translate }}</strong>
        </p>
        <p>{{ user()?.phone }}</p>
      </div>
      <lds-button [expand]="editDataButtonExpand()" [size]="editDataButtonSize()" (clicked)="toggleEditMode()">
        <p class="text-fg-white">
          {{ 'EDIT_DATA_BUTTON' | translate }}
        </p>
      </lds-button>
      <p class="text-orange-50 mt-6 cursor-pointer" (click)="changePassword()">
        <strong>{{ 'CHANGE_PASSWORD_BUTTON' | translate }}</strong>
      </p>
    </div>
  </div>
}
